import { useCallback, useEffect, useState } from 'react'
import type { Supplier } from './types'

function useSuppliers(uuid?: string | undefined | null) {
	const [suppliers, setSuppliers] = useState<Supplier[]>([])

	const [loading, setLoading] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)

	const doQuery = useCallback(async () => {
		//if (!uuid) return
		setLoading(true)
		setError(null)
		let data: Supplier[] = []

		try {
			const response = { ok: true } //await _getSuppliers(uuid)

			if (response && response.ok) {
				//const res = await response.json()
				//data = res.suppliers
				data = [
					{
						uuid: '1',
						company: 'Testi Oy',
						firstName: 'Matti',
						lastName: 'Meikäläinen',
						email: 'matti.meikalainen@example.com',
						group: 'Rakennus',
					},
				]
			} else {
				throw new Error('Response is not ok.')
			}
		} catch (err) {
			console.error('Error fetching suppliers:', err)
			setError('An error occurred while fetching suppliers: ' + uuid)
		}
		setSuppliers(data)
		setLoading(false)
	}, [uuid])

	useEffect(() => {
		doQuery()
	}, [doQuery])

	return {
		suppliers,
		loading,
		error,
		refresh: doQuery,
	}
}

export type useSuppliersResult = ReturnType<typeof useSuppliers>

export default useSuppliers
